define.alias("ember-math-helpers/helpers/asinh", "calendar/helpers/asinh");